import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { ObservationPhoto } from '../../types';

export interface UploadingPhoto extends ObservationPhoto {
  uploading?: boolean;
  error?: string;
  /** Local blob URL for the in-modal thumbnail. */
  previewUrl: string;
}

interface Props {
  photos: UploadingPhoto[];
  onRemove: (index: number) => void;
}

const ObservationPhotoUpload: React.FC<Props> = ({ photos, onRemove }) => {
  if (photos.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2">
      {photos.map((p, i) => (
        <div
          key={p.previewUrl}
          className="relative h-20 w-20 rounded-md overflow-hidden border border-gray-200"
          data-testid={`observation-create-photo-${i}`}
        >
          <img src={p.previewUrl} alt="" className="object-cover w-full h-full" />
          {p.uploading && (
            <div
              data-testid={`observation-create-photo-${i}-progress`}
              className="absolute inset-0 bg-black/40 flex items-center justify-center"
            >
              <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            </div>
          )}
          {p.error && (
            <div className="absolute inset-0 bg-red-500/70 flex items-center justify-center text-xs text-white">
              {p.error}
            </div>
          )}
          <button
            type="button"
            data-testid={`observation-create-photo-${i}-remove`}
            onClick={() => onRemove(i)}
            className="absolute top-0.5 right-0.5 bg-white rounded-full p-0.5"
            aria-label="Remove photo"
          >
            <XMarkIcon className="h-4 w-4 text-gray-700" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ObservationPhotoUpload;
